module.exports = __webpack_public_path__ + "static/media/step-2.c25192c5.png";